import { t } from '@lingui/core/macro';
import { AssemblyIndustry } from '@luminovo/api-contracts';
import { FieldSelect, FieldSelectProps } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';
import type { JSX } from 'react';

import { assemblyIndustryTranslations } from '../../i18n';

type FieldIndustrySelectProps = Omit<FieldSelectProps<AssemblyIndustry | ''>, 'options'>;

export const FieldIndustrySelect = (props: FieldIndustrySelectProps): JSX.Element => {
    const industries = Object.keys(assemblyIndustryTranslations) as AssemblyIndustry[];

    return (
        <FieldSelect
            getOptionLabel={(option) => (Boolean(option) ? transEnum(option, assemblyIndustryTranslations) : '')}
            options={industries}
            placeholder={t`Please select an industry`}
            {...props}
        />
    );
};
